import React, { useEffect, useState } from 'react'
 import PropTypes from "prop-types"
import { toast } from "react-toastify";
import Select from "react-select";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    Modal,
} from "reactstrap"
import SalesRepsService from 'services/Admin/SalesRepsService';
import { SuccessOk } from 'configs/statusCode';

function DeleteModal(props) {
    const [loading, setLoading] = useState(false)
    const [salesRep, setSalesRep] = useState([])
    const salesRepsService = new SalesRepsService()
    const [formState, setFormState] = useState({new_sales_rep: ''})

    useEffect(()=>{
        salesRepsService.getDropDown().then(res=> {
            let data =[]
            if (res && res.status === SuccessOk) {
                res?.data?.map(item => data?.push({id: item.id, label: item.name, value: item.name}))
            }
            data= data?.filter(item => item.id !== props.deletedItem.id)
            setSalesRep([...data])
        })
    },[])

    const handleValidSubmit = () => {
        if(!formState.new_sales_rep){
            toast.error("Select Sales Rep")
            return
        }
        setLoading(true)
        let data = {
            new_sales_rep: formState.new_sales_rep.id
        }
        salesRepsService?.deleteSalesRep(props.deletedItem.id, data).then(res=>{
            if (res && res.status === SuccessOk){
                setLoading(false)
                toast.success("Sales Rep Deleted Successfully")
                props.onCloseModal('close')
                props.setShouldGetData(true)
            }
        })
    }

    return (
        <Modal isOpen={props.open}  toggle={() => props.onCloseModal('close')}  style={{marginTop:"10%"}}>
                <div className="modal-header border-0">
                    <h5 className="modal-title mt-0" id="myModalLabel">
                        {/* <img src={deleteImg} alt="delete" /> Delete {props.titleMsg} */}
                        <p className="fw-bold font-size-15 mb-0">  Removing Sales Representative </p>
                        <p className="text-muted font-size-13 mt-0 ">Who can manage the appointments</p>
                    </h5>
                    <button
                        type="button"
                        onClick={() => props.onCloseModal('close')}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                {/* <div className="modal-body border-0 mb-0">
                    <p>
                        {`Kindly note that this action can't be undone and the ${props.titleMsg} details will get deleted.`}
                    </p>
                </div> */}
                <Row className="mt-2 mb-3 ">
                    <Col md={1}></Col>
                    <Col md={10}>
                    <Select
                        placeholder='Select'
                        options={salesRep}
                        onChange={(data) => {
                            setFormState({ ...formState, new_sales_rep: data });
                        }}
                        value={formState.new_sales_rep}
                    />
                    </Col>
                </Row>
                <div className="modal-footer border-0">
                    <button
                        type="submit"
                        onClick={handleValidSubmit}
                        className="btn w-100 btn-success waves-effect"
                        disabled={loading}
                    >
                        Delete
            </button>
                </div>
            </Modal>
    )
}

DeleteModal.propTypes = {
    open: PropTypes.bool,
    onCloseModal: PropTypes.func,
    handleTableChange: PropTypes.func,
    deletedItem: PropTypes.object,
    modelService: PropTypes.object,
    titleMsg: PropTypes.string
};

export default DeleteModal
